import React from "react";
import { FaToggleOff } from "react-icons/fa"; // Import switch icon
import { useGlobalState } from "../contexts/GlobalStateContext";

const LoginButton = () => {
  const { setShowLogins } = useGlobalState(); // Get from global state

  return (
    <button
      onClick={() => setShowLogins(true)}
      style={{
        position: "absolute",
        right: "15px",
        top: "15px",
        display: "flex", // Use flexbox
        alignItems: "center", // Align icon & text
        gap: "8px", // Space between icon & text
        padding: "5px 10px",
        cursor: "pointer",
        backgroundColor: "#303030",
        color: "lightgreen",
        border: "none",
        borderRadius: "20px",
        fontSize: "16px",
        fontWeight: "bold",
        transition: "background-color 0.3s ease",
      }}
    >
      <FaToggleOff size={20} style={{ verticalAlign: "middle" }} /> 
    </button>
  );
};

export default LoginButton;
